// 使用localStorage代替Cookies
const TokenKey = 'travel_token'

/**
 * 获取token
 * @param {string} type - token类型，如'user'、'admin'或'student'
 * @returns {string} token值
 */
export function getToken(type = 'user') {
  let key = TokenKey
  if (type === 'admin') {
    key = 'admin_token'
  } else if (type === 'student') {
    key = 'student_token'
  }
  return localStorage.getItem(key)
}

/**
 * 设置token
 * @param {string} token - token值
 * @param {string} type - token类型，如'user'、'admin'或'student'
 * @returns {string} token值
 */
export function setToken(token, type = 'user') {
  let key = TokenKey
  if (type === 'admin') {
    key = 'admin_token'
  } else if (type === 'student') {
    key = 'student_token'
  }
  localStorage.setItem(key, token)
  
  return token
}

/**
 * 移除token
 * @param {string} type - token类型，如'user'、'admin'或'student'
 * @returns {void}
 */
export function removeToken(type = 'user') {
  let key = TokenKey
  if (type === 'admin') {
    key = 'admin_token'
  } else if (type === 'student') {
    key = 'student_token'
  }
  localStorage.removeItem(key)
}


/**
 * 检查是否登录
 * @param {string} type - 用户类型，如'user'或'admin'
 * @returns {boolean} 是否已登录
 */
export function isLoggedIn(type = 'user') {
  const hasToken = !!getToken(type)
  return hasToken
}